import { Box, Button, ButtonGroup } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { AdaptedSelect, Optional, TextareaControl } from "../components/Form";

export interface ICreateTemporaryBlockValues {
  reason: string;
  hours: string;
}

interface ITemporaryBlockForm {
  onSubmit: (values: ICreateTemporaryBlockValues) => void;
  initialValues?: Optional<ICreateTemporaryBlockValues>;
}

export const TemporaryBlockForm: React.FC<ITemporaryBlockForm> = ({
  onSubmit,
  initialValues,
}) => {
  const { t } = useTranslation();

  const validate = (values) => {
    const errors: { [key: string]: string } = {};

    if (!values.reason) {
      errors.reason = "Fushë e detyruar";
    }

    if (!values.hours) {
      errors.hours = "Fushë e detyruar";
    }

    return errors;
  };

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues}
      render={({
        handleSubmit,
        form,
        errors,
        submitting,
        pristine,
        values,
      }) => (
        <Box as="form" p={2} onSubmit={handleSubmit}>
          <Field
            name="hours"
            component={AdaptedSelect}
            label={t("patients.temporaryBlock.duration")}
          >
            <option value={1}>1 orë</option>
            <option value={3}>3 orë</option>
            <option value={24}>1 ditë</option>
          </Field>
          <TextareaControl
            name="reason"
            label={t("patients.temporaryBlock.reason")}
          />

          <ButtonGroup spacing={4}>
            <Button
              isLoading={submitting}
              loadingText="Duke dërguar"
              variantColor="teal"
              type="submit"
            >
              {t("forms.save")}
            </Button>
            <Button
              variantColor="teal"
              variant="outline"
              onClick={form.reset}
              isDisabled={submitting || pristine}
            >
              {t("forms.clear")}
            </Button>
          </ButtonGroup>
        </Box>
      )}
    />
  );
};
